import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SwimmingPoolForm from "../Components/SwimmingPoolForm";
import { getSwimmingPoolCompany, updateSwimmingPoolCompany } from "../Reducers/actions";

const SwimmingPoolEditPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getSwimmingPoolCompany(id));
  }, [dispatch, id]);

  const handleSubmit = (values) => {
    dispatch(updateSwimmingPoolCompany(id, values)).then((result) => {
      if (result.success) {
        alert("Zwembad succesvol bijgewerkt!");
        navigate("/zwembadinspecties/zwembaden");
      } else {
        alert("Er is een fout opgetreden bij het bijwerken van het zwembad.");
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3>Zwembad Bewerken</h3>
            </div>
            <div className="card-body">
              <SwimmingPoolForm onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwimmingPoolEditPage;
